import React from 'react';
import { AlertCircle } from 'lucide-react';

export default function UnderConstructionBanner({ message }) {
  return (
    <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white py-3 px-4 fixed top-0 left-0 right-0 z-[60] shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-center">
        <div className="flex items-center space-x-3">
          <AlertCircle className="h-5 w-5 flex-shrink-0" />
          <p className="text-sm sm:text-base font-medium text-center">
            {message || "Site Under Construction: We're currently updating our website. Some features and content may be incomplete, outdated, or inaccurate. Thank you for your patience as we improve your experience!"}
          </p>
        </div>
      </div>
    </div>
  );
}
